import { render, staticRenderFns } from "./KUpload.vue?vue&type=template&id=125d167c&scoped=true"
import script from "./KUpload.vue?vue&type=script&lang=js"
export * from "./KUpload.vue?vue&type=script&lang=js"
import style0 from "./KUpload.vue?vue&type=style&index=0&id=125d167c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d167c",
  null
  
)

export default component.exports